import { useAnalytics } from '@/hooks/use-analytics'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { useEffect, useRef } from 'react'

import { OrdersTable } from './-components/orders-table'

function OrderEntryPage() {
  const { capture } = useAnalytics()
  const viewedRef = useRef(false)

  useEffect(() => {
    if (viewedRef.current)
      return
    viewedRef.current = true
    capture('orders_inbox_viewed', {})
  }, [capture])

  return (
    <div className="flex flex-col gap-6 px-4 py-4 lg:px-6 md:py-6">
      <OrdersTable />
    </div>
  )
}

export const Route = createFileRoute('/_authed/_user/orders/')({
  beforeLoad: ({ context }) => {
    if (!context.auth.canUseOrderInbox) {
      throw redirect({ to: '/' })
    }
  },
  component: OrderEntryPage,
})
